module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-down-left-e6a8e7a50a24e0248e8e560e2a3f54f9.svg";